module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_AboutUs_EN_Mobile.1ed8a1bb.webp";